export class Utilities {
    private static geniusLinkGroupId = 16326;
    static makeArrayOfLength = (length:number):any[] => {
        return new Array(length);
    }
    
    static linkBuilder = {
        createAmazonLink: (searchText:string):string => {
            var amazonUrl = `http://www.amazon.com/gp/search?ie=UTF8&camp=1789&creative=9325&index=books&keywords=${encodeURIComponent(searchText)}&linkCode=ur2`;
            var geniusLink = `http://target.georiot.com/Proxy.ashx?tsid=${Utilities.geniusLinkGroupId}&GR_URL=${encodeURIComponent(amazonUrl)}`;
            return geniusLink;
        },
        createAmazonLinkFromISBN: (isbn:string):string => {
            if (!isbn) return '';
            var amazonUrl = `https://www.amazon.com/gp/product/${Utilities.ISBN13to10(isbn)}`;
            var geniusLink = `http://target.georiot.com/Proxy.ashx?tsid=${Utilities.geniusLinkGroupId}&GR_URL=${encodeURIComponent(amazonUrl)}`;
            return geniusLink;
        },
        createAddLibraLink: (isbn:string):string => {
            if (!isbn) return '';
            return `https://www.addlibra.com/store/item/-/${isbn}?8d1e967197954e6dbb308e30f72609de`;
        }
    }
    
    static spellOutNumber = (num:number):string => {
        var numbers = {1: "one", 2: "two", 3: "three", 4: "four", 5: "five", 6: "six", 7: "seven", 8: "eight", 9: "nine"};
        return numbers[num];
    }
    
    static preventBubbling = ($event:any):void => {
        if ($event.stopPropagation) $event.stopPropagation();
        if ($event.preventDefault) $event.preventDefault();
    }

    static isNotNull = (val) => val !== null; 

    static compareArrayOfStrings(a:string[], b:string[]) {
        if (a.length != b.length) return false;

        var as = a.sort();
        var bs = b.sort();
        
        for (var i = 0; i < as.length; i++) {
            if (as[i] !== bs[i]) return false;
        }

        return true;
    }

    // hack until stacked modals are supported
    // https://github.com/ng-bootstrap/ng-bootstrap/issues/643
    static reAddModalOpen() {
        setTimeout(() => {
            if (document.querySelector('body > .modal')) {
                console.log('re-adding modal-open')
                document.body.classList.add('modal-open');
            }
        }, 500);
    }

    
    static ISBN13to10(isbn13) {
        isbn13 = isbn13.replace(/[- ]/gi, '');

        isbn13 = isbn13.substr(3, 9);
        let j = 0;
        let check = 0;
        for (let i = 10; i > 1; i--) {
            check += parseInt(isbn13[j++]) * i;
        }
        check = 11 - (check % 11);
        isbn13 = isbn13.concat(check === 11 ? '0' : check === 10 ? 'X' : check.toString());
        return isbn13;
    }
}


// WEBPACK FOOTER //
// ./web/static/services/Utilities.ts